import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import WordmarkTrace from "../components/site/WordmarkTrace";
import EditorialMarquee from "../components/site/EditorialMarquee";
import Services from "../components/site/Services";
import ElevareCycle from "../components/site/ElevareCycle";
import HowItWorks from "../components/site/HowItWorks";
import Positioning from "../components/site/Positioning";
import IdealClient from "../components/site/IdealClient";
import Predictor from "../components/site/Predictor";
import Pricing from "../components/site/Pricing";
import PackageComparison from "../components/site/PackageComparison";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import ChapterRail from "../components/site/ChapterRail";
import WaveDivider from "../components/site/WaveDivider";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Header />
      <ChapterRail />
      <main>
        <Hero />
        <WordmarkTrace />
        <EditorialMarquee />
        <Services />
        <WaveDivider variant="cream" />
        <ElevareCycle />
        <HowItWorks />
        <Positioning />
        <IdealClient />
        <Predictor />
        <WaveDivider variant="sand" flip />
        <Pricing />
        <PackageComparison />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
